import React,{useEffect} from 'react'
import Layout from '../Layout'
import FormProfileTimologia from '../../components/timologia_components/FormProfileTimologia'
import { useDispatch,useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { getMe } from '../../features/authSlice'

const ProfileTimologio = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const {isError} = useSelector((state=>state.auth));

  useEffect(()=>{
      dispatch(getMe());
  },[dispatch]);

  useEffect(()=>{
      if(isError){
          navigate("/");
      }
  },[isError,navigate]);
  return (
    <Layout>
        <FormProfileTimologia/>
    </Layout>
  )
}

export default ProfileTimologio